// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_HLj","cls2":"JournalSubscriptionPage-cls2_CzR JournalSubscriptionPage-cls1_HLj"};